export const CATEGORY = "/category";
export const PRODUCT = "/product";
export const CART = "/cart";

export const LOGIN = "/login";
export const REGISTER = "/register";
